<template>
  <img
    :ref="'imgRetry'"
    :src="src"
    @error="errorImg"
    class="z2-img" />
</template>

<script>
export default {
  props: ["src", "retryMax"],
  methods: {
    errorImg() {
      const image = this.$refs.imgRetry;
      image.onerror = null;
      image.retries = image.retries ? image.retries + 1 : 1;
      const retriesMax = this.retryMax || 4;
      if (image.retries < retriesMax) {
        setTimeout(function () {
          image.src += `&ts${image.retries + "=" + new Date().getTime()}`;
        }, 2000);
      }
    },
  },
};
</script>

<style>
</style>